import React from "react";
import { withTranslation } from "react-i18next";
import { Button, Form, Segment } from "semantic-ui-react";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";

import RevalidateOnLanguageChange from "../../../common/RevalidateOnLanguageChange";
import "../../../common/layout/AuthLayout.css";

class ForgotPassword extends React.Component {
    onSubmitBtnClick(values) {
        const { handleSubmitBtn } = this.props;
        handleSubmitBtn(values);
    }

    render() {
        const { isLoading } = this.props;
        return (
            <div className="s-login-form auth-layout-container">
                <div className="s-login-body">
                    <Segment className="rounded-4 border-0 signup-form-container">
                        <Form size="large" autoComplete="off">
                            <Formik
                                initialValues={{ email: "" }}
                                onSubmit={(values) => this.onSubmitBtnClick(values)}
                                validationSchema={Yup.object().shape({
                                    email: Yup.string()
                                        .email(this.props.t("app.auth.validationInvalidEmail"))
                                        .max(100, this.props.t("app.auth.validationMaxChars"))
                                        .required(this.props.t("app.auth.validationEmailRequired")),
                                })}
                            >
                                {({ values, handleSubmit }) => (
                                    <div>
                                        <RevalidateOnLanguageChange language={this.props.i18n.language} />
                                        <div className="text-center" style={{ marginBottom: "12px", lineHeight: 0, padding: "0" }}>
                                            <img
                                                src="/assets/img/logo2.png"
                                                alt={this.props.t("app.auth.logoAlt")}
                                                style={{
                                                    width: "20%",
                                                    height: "auto",
                                                    display: "block",
                                                    margin: "0 auto",
                                                    objectFit: "contain"
                                                }}
                                            />
                                        </div>
                                        <h2 className="text-center">{this.props.t("app.auth.forgotPasswordTitle")}</h2>
                                        <p className="text-center text-muted mb-4" style={{ fontSize: "14px", marginTop: "8px" }}>
                                            {this.props.t("app.auth.forgotPasswordDescription")}
                                        </p>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <label htmlFor="email" className="form-label mt-2">
                                                        {this.props.t("app.auth.emailAddress")}
                                                    </label>
                                                    <ErrorMessage
                                                        name="email"
                                                        component="div"
                                                        className="text-danger fs-6"
                                                    />
                                                </div>
                                                <Field
                                                    name="email"
                                                    type="email"
                                                    placeholder={this.props.t("app.auth.emailPlaceholder")}
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <Button
                                                loading={isLoading}
                                                color="blue"
                                                type="submit"
                                                fluid
                                                size="large"
                                                className="my-3 fw-normal"
                                                onClick={() => handleSubmit(values)}
                                            >
                                                {isLoading ? this.props.t("app.auth.sending") : this.props.t("app.auth.sendResetLink")}
                                            </Button>
                                            <div
                                                style={{
                                                    fontSize: "14px",
                                                }}
                                                className="d-flex justify-content-center align-items-center w-100 mt-3"
                                            >
                                                {this.props.t("app.auth.rememberPassword")}
                                                <Link
                                                    to="/login"
                                                    className="text-center ms-2 text-custom-primary"
                                                >
                                                    {this.props.t("app.auth.signIn")}
                                                </Link>
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: "14px",
                                                }}
                                                className="d-flex justify-content-center align-items-center w-100 mt-2"
                                            >
                                                {this.props.t("app.auth.dontHaveAccount")}
                                                <Link
                                                    to="/register"
                                                    className="text-center ms-2 text-custom-primary"
                                                >
                                                    {this.props.t("app.auth.signUp")}
                                                </Link>
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: "12px",
                                                    marginTop: "20px",
                                                }}
                                                className="d-flex justify-content-center align-items-center w-100 gap-2"
                                            >
                                                <a
                                                    href="https://timeoffledger.com/cookie-settings"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-muted"
                                                    style={{ textDecoration: "none" }}
                                                >
                                                    {this.props.t("app.auth.cookieSettings")}
                                                </a>
                                                <span className="text-muted">|</span>
                                                <a
                                                    href="https://timeoffledger.com/cookie-policy"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-muted"
                                                    style={{ textDecoration: "none" }}
                                                >
                                                    {this.props.t("app.auth.cookiePolicy")}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Formik>
                        </Form>
                    </Segment>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ForgotPassword);

